import { render, staticRenderFns } from "./etusivu-kouluttaja.vue?vue&type=template&id=a895928a&"
import script from "./etusivu-kouluttaja.vue?vue&type=script&lang=ts&"
export * from "./etusivu-kouluttaja.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports